export default {
  validateChild: {
    inserted: (el, binding, vnode) => {
      let child = vnode.componentInstance._data.validator.namespace
      let parent = vnode.context._data.validator
      if (child && !parent.children.some(x => x === child)) parent.children.push(child)
    },
    unbind: (el, binding, vnode) => {
      let child = vnode.componentInstance._data.validator.namespace
      let parent = vnode.context._data.validator
      if (child && parent.children.some(x => x === child)) parent.children = parent.children.filter(x => x !== child)
    }
  },
  validateChildIf: {
    update: (el, binding, vnode) => {
      if (binding.value === binding.oldValue) return
      let child = vnode.componentInstance._data.validator.namespace
      let parent = vnode.context._data.validator
      if (binding.value && child && !parent.children.some(x => x === child)) parent.children.push(child)
      else if (!binding.value) {
        parent.children = parent.children.filter(x => x !== child)
        vnode.componentInstance.resetValidation()
      }
    },
    unbind: (el, binding, vnode) => {
      let child = vnode.componentInstance._data.validator.namespace
      let parent = vnode.context._data.validator
      if (child && parent.children.some(x => x === child)) parent.children = parent.children.filter(x => x !== child)
    }
  },
  validateBeforeNext: {
    inserted: (el, binding, vnode) => {
      let y = vnode.componentInstance
      if (y.$parent && y.$parent.$options._componentTag !== 'bkn-step') return
      let child = vnode.componentInstance._data.validator.namespace
      let parent = y.$parent._data.validator
      if (child && !parent.children.some(x => x === child)) parent.children.push(child)
    },
    unbind: (el, binding, vnode) => {
      let y = vnode.componentInstance
      if (y.$parent && y.$parent.$options._componentTag !== 'bkn-step') return
      let child = vnode.componentInstance._data.validator.namespace
      let parent = y.$parent._data.validator
      if (child && parent.children.some(x => x === child)) parent.children = parent.children.filter(x => x !== child)
    }
  }
}
